import { render, staticRenderFns } from "./Movie.vue?vue&type=template&id=7c5dd084&"
import script from "./Movie.vue?vue&type=script&lang=js&"
export * from "./Movie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports